if (!customElements.get("m-countdown-timer")) {
  class MCountdownTimer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const time = this.dataset.time;
      if (!time) return;

      // Robust date parsing to handle single digits and different formats (e.g., YYYY-M-D)
      let endTime;
      try {
        const parts = time.split(/[\sT]/);
        if (parts.length >= 1) {
          const dateParts = parts[0].split(/[-/]/);
          const timeParts = parts[1] ? parts[1].split(':') : [0, 0, 0];

          if (dateParts.length === 3) {
            const year = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10) - 1;
            const day = parseInt(dateParts[2], 10);
            const hour = parseInt(timeParts[0], 10) || 0;
            const minute = parseInt(timeParts[1], 10) || 0;
            const second = parseInt(timeParts[2], 10) || 0;

            const date = new Date(year, month, day, hour, minute, second);
            endTime = date.getTime();
          }
        }
      } catch (e) {
        console.error("Error parsing countdown date:", e);
      }

      // Fallback to Date.parse if manual parsing failed
      if (!endTime || isNaN(endTime)) {
        endTime = Date.parse(time.split(" ").join("T"));
      }

      if (endTime && !isNaN(endTime)) {
        const TimerClass = window.CountdownTimer || (window.MinimogTheme && window.MinimogTheme.CountdownTimer);
        
        if (TimerClass) {
          new TimerClass(this, Date.now(), endTime);

          if (endTime > Date.now()) {
            this.classList.remove("hidden");
            this.classList.remove("m:hidden");
          }
        } else {
          console.error("CountdownTimer class not found");
          this.style.removeProperty("opacity"); // Show anyway if timer class is missing
        }
      } else {
        console.error("Invalid countdown date:", time);
        this.style.removeProperty("opacity"); // Show "00" if date is invalid
      }
    }
  }

  customElements.define("m-countdown-timer", MCountdownTimer);
}
